// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"308":"746929c1","860":"0b074ab8"}[chunkId] + ".chunk.js";
};